import axios from 'axios';
import { mainBaseUrl } from '@/apis/appconst';

const API_BASE_URL = mainBaseUrl+'faq';
export async function addFaq(faq_title, faq_cat, faq_cat1, faq_ans) {
    try {
        const response = await axios.post(`${API_BASE_URL}/add_faq`, {
            faq_title,
            faq_cat,
            faq_cat1,
            faq_ans
        });

        return response.data;
    } catch (error) {
        return {
            status: false,
            type: "danger",
            message: error.response?.data?.message || error.message
        };
    }
}

export async function updateFaq(faqId, faq_title, faq_cat, faq_cat1,faq_ans) {
    try {
        const response = await axios.post(`${API_BASE_URL}/update_faq/${faqId}`, {
            faq_title,
            faq_cat,
            faq_cat1,
            faq_ans
        });

        return response.data;
    } catch (error) {
        return {
            status: false,
            type: "danger",
            message: error.response?.data?.message || error.message
        };
    }
}

export async function delFaq(faqId) {
    try {
        const response = await axios.post(`${API_BASE_URL}/del_faq/${faqId}`);

        return response.data;
    } catch (error) {
        return {
            status: false,
            type: "danger",
            message: error.response?.data?.message || error.message
        };
    }
}

export async function getFaqs(page_no,page_count, search_key) {
    try {
        const response = await axios.post(`${API_BASE_URL}/get_faqs`, null, {
            params: {
                page_no,
                search_key,
                page_count
            }
        });

        return response.data;
    } catch (error) {
        return {
            status: false,
            type: "danger",
            message: error.response?.data?.message || error.message
        };
    }
}

export async function getReports(page_no,page_count) {
    try {
        const response = await axios.post(`${API_BASE_URL}/get_reports`, null, {
            params: {
                page_no,
                page_count
            }
        });

        return response.data;
    } catch (error) {
        return {
            status: false,
            type: "danger",
            message: error.response?.data?.message || error.message
        };
    }
}


export async function getFaqById(faqId) {
    try {
        const response = await axios.post(`${API_BASE_URL}/get_faq_by_id/${faqId}`);

        return response.data;
    } catch (error) {
        return {
            status: false,
            type: "danger",
            message: error.response?.data?.message || error.message
        };
    }
}
